<template>
  <v-app>
    <v-main style="height: 100vh; width: 100%; background-color: #fff;">
        <div style="font-size: 2rem; color: #ff5722; text-align: center; margin-top:5%;">
          INVALID URL!!!
        </div>
    </v-main>
  </v-app>
</template>

<script>
export default {};
</script>

<style>
</style>